/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} StandingsInputs */

const th_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตารางคะแนน`)
};

const en_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standings`)
};

const ja_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位表`)
};

const zh_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分榜`)
};

const es_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación`)
};

const pt_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação`)
};

const id_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasemen`)
};

const fr_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement`)
};

const tl_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan`)
};

const vi_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng xếp hạng`)
};

const ko_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

const de_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabelle`)
};

const ru_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблица`)
};

const tr_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puan durumu`)
};

const it_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifica`)
};

const pl_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela`)
};

const uk_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблиця`)
};

const hi_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक तालिका`)
};

const ar_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترتيب`)
};

const ms_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan`)
};

const bn_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পয়েন্ট তালিকা`)
};

const zh_tw2_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積分榜`)
};

const zh_hk2_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積分榜`)
};

const ur_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوائنٹس ٹیبل`)
};

const fa_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدول`)
};

const sw_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msimamo`)
};

const nl_standings = /** @type {(inputs: StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand`)
};

/**
* | output |
* | --- |
* | "Standings" |
*
* @param {StandingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const standings = /** @type {((inputs?: StandingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<StandingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_standings(inputs)
	if (locale === "ja") return ja_standings(inputs)
	if (locale === "zh") return zh_standings(inputs)
	if (locale === "es") return es_standings(inputs)
	if (locale === "pt") return pt_standings(inputs)
	if (locale === "id") return id_standings(inputs)
	if (locale === "fr") return fr_standings(inputs)
	if (locale === "tl") return tl_standings(inputs)
	if (locale === "vi") return vi_standings(inputs)
	if (locale === "ko") return ko_standings(inputs)
	if (locale === "de") return de_standings(inputs)
	if (locale === "ru") return ru_standings(inputs)
	if (locale === "tr") return tr_standings(inputs)
	if (locale === "it") return it_standings(inputs)
	if (locale === "pl") return pl_standings(inputs)
	if (locale === "uk") return uk_standings(inputs)
	if (locale === "hi") return hi_standings(inputs)
	if (locale === "ar") return ar_standings(inputs)
	if (locale === "ms") return ms_standings(inputs)
	if (locale === "bn") return bn_standings(inputs)
	if (locale === "zh-TW") return zh_tw2_standings(inputs)
	if (locale === "zh-HK") return zh_hk2_standings(inputs)
	if (locale === "ur") return ur_standings(inputs)
	if (locale === "fa") return fa_standings(inputs)
	if (locale === "sw") return sw_standings(inputs)
	if (locale === "nl") return nl_standings(inputs)
	return en_standings(inputs)
});